<script>
export default {
  name: "progressBar",
  data: function() {
    return {
      progressMessage: "",
      progressCurrent: 0,
      progressTotalItem: 0,
      progressPercentage: "",
      currentItemInfo: "",
      progressClose: true,
    };
  },
  created() {
    // Listen to score changes coming from SignalR events
  },
  methods: {
    // This is called from the server through SignalR
    onProgressChanged({
      message,
      currentItem,
      totalItem,
      percentage,
      currentItemInfo,
      closeProgressBar,
    }) {
      this.progressMessage = message;
      this.progressCurrent = currentItem;
      this.progressTotalItem = totalItem;
      this.progressPercentage = percentage;
      this.currentItemInfo = currentItemInfo;
      this.progressClose = closeProgressBar;
      // if (this.progressCurrent == this.progressTotalItem) {
      //   this.progressClose = true;
      // }else{
      //   this.progressClose = closeProgressBar;
      // }
    },
  },
  computed: {
    currentPercentage: function() {
      let currentItem = this.progressCurrent;
      let totalItem = this.progressTotalItem;

      let percentage = (parseInt(currentItem) / parseInt(totalItem)) * 100;
      return percentage;
    },
    showDialog: function() {
      return !this.progressClose;
    },
  },
};
</script>

<template>
  <div id="progressBar">
    <v-dialog v-model="showDialog" persistent width="450">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          {{ this.progressMessage }} <br />
          ({{ this.progressCurrent }}/{{
            this.progressTotalItem + this.currentItemInfo
          }})
          <v-progress-linear
            v-model="currentPercentage"
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.v-progress-linear__bar,
.v-progress-linear__bar__determinate {
  transition: none;
}
</style>
